/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

export interface IOrganization {
    nome_fantasia: string;
    registro: string;
    razao_social: string;
    telefone_geral: string;
    unidade_operacional: string;
    atividade_principal: string;
    produto: string;
    cidade: string;
    estado: string;
    pais: string;
    datum: string;
    fuso_zona?: number;
    hemisferio?: string;
    utm_ns?: number;
    utm_ew?: number;

    id_empresa?: string,
    email_geral?: string;
    producao_anual?: number;
    qtd_empregados?: number;
    site?: string;
    descricao_acesso?: string;

    cep: string;
    rua?: string;
    bairro?: string;
    numero?: string;
    complemento?: string;
    latitude?: number;
    longitude?: number;

    status?: boolean;
}

export interface IListEmpreendimentos {
    nome_fantasia: string,
    razao_social: string
	status: boolean,
	uuid: string,
    empresa: string
}


const listAdm = async (): Promise<IListEmpreendimentos[] | Error> => {
    
    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get('./empreendimentos', {
            headers: {
                Authorization: `${token}`
            }
        });

        if (response.data) {
            return response.data;
        }

        return new Error('Erro ao listar registros.');
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro na requisição de listagem.');
    }
};


const get = async (uuid:string): Promise<IListEmpreendimentos[] | Error> => {

    
    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./empreendimentos?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if (response.data) {
            return response.data;
        }

        return new Error('Erro ao listar registros.');
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro na requisição de listagem.');
    }
};

const delet = async(uuid: string): Promise<any | Error> => {

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.delete('./empreendimento', {
            headers: {
                Authorization: `${token}`
            },
            params: {
                'uuid': uuid
            }
        });

        if(response.data){
            return response.data; 
        }

        return new Error('Falha ao deletar empresa');
    } catch (error) {
        Error((error as { message: string}).message || 'Erro ao deletar empresa');
    }
};

const getById = async(uuid: string): Promise<IOrganization | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get('./empreendimento', {
            params: {
                'uuid': uuid
            },
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao buscar empresa');
    } catch (error) {
        return new Error((error as { message: string }).message || 'Erro ao buscar empresa');
    }
};

const create = async (data: IOrganization): Promise<any | Error> => {

    try {
        await AuthService.verify();
    
        const token = await AuthService.getAccessToken();
    
        const response = await ApiBack.post('/empreendimento', data, {
            headers: {
                Authorization: `${token}` 
            }
        });
    
        if (response.data) {
            return response ;
        }
    
        return new Error('Erro ao criar nova empresa');
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar empresa');
        }
    }
};

const upgrade = async(uuid: string, data: IOrganization): Promise<any | Error> => {

    

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.put(`./empreendimento?uuid=${uuid}`, data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data){
            return response.data;
        }
        
        return new Error('Falha ao atualizar empresa');
    } catch (error) {
        return new Error((error as { menssage: string}).menssage || 'Error ao atualizar empresa');
    }
};

export const OrganizationServices = {
    listAdm,
    get,
    delet,
    getById,
    create,
    upgrade
};